"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1h-1v2.4076a2.9887 2.9887 0 0 0-.3416.1452l-8.4223 4.2111a2.2362 2.2362 0 0 0-1.2361 2C1 18.9989 2.0011 20 3.236 20h17.528C21.9989 20 23 18.9989 23 17.7639a2.236 2.236 0 0 0-1.2361-2l-8.4223-4.2111A2.9887 2.9887 0 0 0 13 11.4076v-.5783c1.1652-.4118 2-1.523 2-2.8293 0-1.6569-1.3431-3-3-3S9 6.3431 9 8h2zm.5528 5.3416-8.4223 4.2112c-.2151.1075-.1392.4472.1056.4472h17.5278c.2448 0 .3207-.3397.1056-.4472l-8.4223-4.2112a1.0003 1.0003 0 0 0-.8944 0z"
  })];
};

exports.default = _default;